module.exports = __webpack_public_path__ + "img/1440.009e63e7.jpg";